<template>
  <div>
    <!-- 盒子 -->

    <div class="border_parent">
      <b-card>
        <b-row type="flex" justify="center">
          <b-col>
            <div class="content" v-for="item of projectList" :key="item.id">
              <a class="border_link" @click.prevent="linkDetails(item.id)">
                <div class="content_left">
                  <b-img fluid :src="item.photoUrl" block style="width: 100%; max-height: 220px">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline image-error-icon"></i>
                    </div>
                  </b-img>
                </div>
                <div class="content_middle">
                  <div class="ProjectTit">{{ item.name }}</div>
                  <div class="content_font">{{ item.description }}</div>
                </div>
                <div class="content_right">
                  <div class="ProjectDate">{{ getMonthAndDay(item.date) }}</div>
                  <div class="content_font">{{ getYear(item.date) }}</div>
                </div>
              </a>
              <el-divider></el-divider>
            </div>
          </b-col>
        </b-row>
        <b-row type="flex" :gutter="10" justify="center">
          <b-col :span="8">
            <div class="pagination">
              <b-pagination v-model="query.pageNum" :total-rows="total" :per-page="query.pageSize" :limit="3" align="center" size="sm" @input="handleCurrentChange">
                <template v-slot:first-text><span class="text-pag">First</span></template>
                <template v-slot:prev-text><span class="text-pag">Prev</span></template>
                <template v-slot:next-text><span class="text-pag">Next</span></template>
                <template v-slot:last-text><span class="text-pag">Last</span></template>
                <template v-slot:ellipsis-text>
                  <b-spinner small type="grow"></b-spinner>
                  <b-spinner small type="grow"></b-spinner>
                  <b-spinner small type="grow"></b-spinner>
                </template>
                <template v-slot:page="{ page, active }">
                  <b v-if="active">{{ page }}</b>
                  <i v-else>{{ page }}</i>
                </template>
              </b-pagination>
              <!-- <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="query.pageNum"
                                :page-sizes="[5, 10, 20]"
                                :page-size="query.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                            </el-pagination> -->
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
export default {
  name: "Project",
  data() {
    return {
      requestUrl: {
        getPage: "/project/page",
      },
      query: {
        name: "",
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      projectList: [],
      iswin: true,
      inMo: false,
      items: [
        { name: "研究项目", id: "1" },
        { name: "论文发表", id: "2" },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取列表数据
    getData() {
      request
        .get(this.requestUrl.getPage, {
          params: this.query,
        })
        .then((res) => {
          if (res.code === "200") {
            this.projectList = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error("获取失败");
          }
        });
    },
    //详情
    linkDetails(id) {
      this.$router.push({
        name: "details",
        query: {
          projectId: id,
          type: "4",
        },
      });
    },
    //修改页
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize;
      this.getData();
    },
    //修改每页条数
    handleCurrentChange(pageNum) {
      this.query.pageNum = pageNum;
      this.getData();
    },
    // 获取年份
    getYear(val) {
      if (val) {
        return val.slice(0, 4);
      } else {
        return new Date().getFullYear();
      }
    },
    // 获取月和日
    getMonthAndDay(val) {
      if (val) {
        return val.slice(5);
      } else {
        const date = new Date();
        let year = date.getMonth() + 1;
        let day = date.getDay();
        year = year < 10 ? "0" + year : year + "";
        day = day < 10 ? "0" + day : day + "";
        return year + "-" + day;
      }
    },
  },
};
</script>

<style scoped>
* {
  font: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei, Tohoma, Arial;
  color: #313131;
}

.text-pag {
  color: #002d71;
  font-weight: bold;
}

h3 {
  color: #333;
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  font-weight: normal;
}

h1 {
  color: #999;
  font-weight: normal;
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  margin: 0, 0, 5px, 0;
}
.content {
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 769px) {
  .border_parent {
    width: 100%;
    margin: auto;
  }
  .ProjectTit {
    font-size: 17px;
    color: #011e4b;
    font-weight: bolder;
  }
  .ProjectDate {
    font-size: small;
    font-weight: bolder;
  }
  .content_font {
    color: #999;
    font-size: xx-small;
  }
  .content_left {
    width: calc(25%);
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content_middle {
    width: 62%;
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .content_right {
    width: calc(13%);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media (min-width: 769px) and (max-width: 1000px) {
  .border_parent {
    width: 100%;
    margin: auto;
  }
  .ProjectTit {
    font-size: 25px;
    color: #011e4b;
    font-weight: bolder;
  }
  .ProjectDate {
    font-size: larger;
    font-weight: bolder;
  }
  .content_font {
    color: #999;
    font-size: medium;
  }
  .content_left {
    width: calc(45%);
    margin-right: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content_middle {
    width: 40%;
    margin-right: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .content_right {
    width: calc(15%);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media (min-width: 1000px) {
  .border_parent {
    width: 100%;
    margin: auto;
  }
  .ProjectTit {
    font-size: 30px;
    color: #011e4b;
    font-weight: bolder;
  }
  .ProjectDate {
    font-size: larger;
    font-weight: bolder;
  }
  .content_font {
    color: #999;
    font-size: medium;
  }
  .content_left {
    width: calc(45%);
    margin-right: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content_middle {
    width: 40%;
    margin-right: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .content_right {
    width: calc(15%);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.image-error-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

/* 修改分隔符样式 */
.el-divider--horizontal {
  margin: 12px 0;
  background: 0 0;
  border-top: 1px dashed #e8eaec;
}
.border_link {
  display: block;
  text-decoration: none;
  display: flex;
}

.border_link:hover {
  cursor: pointer;
}
</style>
